import eventHub from "@/mixins/eventHub";

const WRTC_CONFIG = {
  iceServers: [
    {
      urls: ["stun:stun.l.google.com:19302"]
    }
  ]
};


export class Call {
  constructor(initiator, to, store) {
    this.initiator = initiator
    this.to = to
    this.status = 'ring'
    this.store = store
    this.rtc = null
    this.request = false
    this.interval = null
    this.duration = 0
  }

  connectRtc() {
    this.status = 'connecting'
    this.rtc = new RTCPeerConnection(WRTC_CONFIG)

    this.rtc.onicecandidate = this.handleICECandidateEvent.bind(this);
    this.rtc.ontrack = this.handleTrackEvent.bind(this);
    this.rtc.onnegotiationneeded = this.handleNegotiationNeededEvent.bind(this);
    this.rtc.onremovetrack = this.handleRemoveTrackEvent.bind(this);
    this.rtc.oniceconnectionstatechange = this.handleICEConnectionStateChangeEvent.bind(this);
    this.rtc.onicegatheringstatechange = this.handleICEGatheringStateChangeEvent.bind(this);
    this.rtc.onsignalingstatechange = this.handleSignalingStateChangeEvent.bind(this);

    this.store.state.micStream.getTracks().forEach(track => this.rtc.addTrack(track, this.store.state.micStream))
  }

  handleICECandidateEvent(event) {
    if (event.candidate) {
      this.store.dispatch('callApi', {name: 'sendToUser', payload: {id: this.to.id, message: event.candidate, event: 'rtcCandidate'}})
    }
  }

  declareCallStarted(event) {
    this.status = 'connected'
    eventHub.$emit('callReady', event) // Notify the interested components
    setInterval(() => {
      this.duration += 1
    }, 1000)
  }

  hang() {
    if (this.rtc) {
      this.rtc.onicecandidate = null
      this.rtc.ontrack = null
      this.rtc.onnegotiationneeded = null
      this.rtc.onremovetrack = null
      this.rtc.oniceconnectionstatechange = null
      this.rtc.onicegatheringstatechange = null
      this.rtc.onsignalingstatechange = null
      this.rtc.close()
    }
    this.status = 'no-call'
    this.store.state.call = null
    if (this.interval) {
      clearInterval(this.interval)
    }
  }


  // This means the connection is established
  handleTrackEvent(event) {
    this.declareCallStarted(event)
  }

  handleNegotiationNeededEvent(event) {
    event
    if (this.initiator) {
      this.rtc
        .createOffer()
        .then((offer) => {
          return this.rtc.setLocalDescription(offer)
        })
        .then(() => {
          this.store.dispatch('callApi', {name: 'sendToUser', payload: {id: this.to.id, message: this.rtc.localDescription, event: 'rtcOffer'}})
        })
        .catch((e) => {
          console.error(e);
        })
    }
  }

  handleRemoveTrackEvent() {
  }

  handleICEConnectionStateChangeEvent(event) {
    if (["disconnected", "failed", "closed"].includes(event.target.iceConnectionState)) {
      this.hang()
    }
  }

  handleICEGatheringStateChangeEvent() {

  }

  handleSignalingStateChangeEvent() {

  }

  addCandidate(candidate) {
    this
      .rtc.addIceCandidate(new RTCIceCandidate(candidate))
      .catch((e) => {console.error(e);})
  }

  handleOffer(offer) {
    const description = new RTCSessionDescription(offer)
    this.rtc
      .setRemoteDescription(description)
      .then(() => {return this.rtc.createAnswer()})
      .then((answer) => {return this.rtc.setLocalDescription(answer)})
      .then(() => {return this.store.dispatch('callApi', {name: 'sendToUser', payload: {id: this.to.id, message: this.rtc.localDescription, event: 'rtcAnswer'}})})
      .catch((e) => {console.error(e);})
  }

  handleAnswer(answer) {
    this.rtc
      .setRemoteDescription(new RTCSessionDescription(answer))
      .catch((e) => {console.error(e);})
  }
}
